import { isPlatformBrowser } from '@angular/common';
import { Injectable, OnDestroy, PLATFORM_ID, inject } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { take } from 'rxjs';

const TIMEOUT_MS = 10 * 60 * 1000;   // 10 minutes
const CHECK_INTERVAL_MS = 5 * 60 * 1000; // check every 5 minutes

@Injectable({ providedIn: 'root' })
export class KnBrInactivityReloadService implements OnDestroy {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly authService = inject(AuthService);

  private intervalId: ReturnType<typeof setInterval> | null = null;
  private readonly pageLoadTime = Date.now();

  init(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    this.intervalId = setInterval(() => {
      if (Date.now() - this.pageLoadTime < TIMEOUT_MS) return;

      this.authService.isUserLoggedIn().pipe(take(1)).subscribe((loggedIn) => {
        if (!loggedIn) {
          window.location.reload();
        }
      });
    }, CHECK_INTERVAL_MS);
  }

  ngOnDestroy(): void {
    if (this.intervalId !== null) clearInterval(this.intervalId);
  }
}